import { render, staticRenderFns } from "./lovely.vue?vue&type=template&id=639b5d5c&scoped=true&"
import script from "./lovely.vue?vue&type=script&lang=js&"
export * from "./lovely.vue?vue&type=script&lang=js&"
import style0 from "./lovely.vue?vue&type=style&index=0&id=639b5d5c&lang=less&scoped=true&"
import style1 from "./lovely.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b5d5c",
  null
  
)

export default component.exports